import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 px-6 bg-brand-blue text-white relative overflow-hidden" data-id="element-148">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-149">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-150"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-151"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-153">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm mb-8" data-id="element-154">
            <Heart className="w-8 h-8 text-white" fill="currentColor" data-id="element-155" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-156">
            La solución: <br className="hidden md:block" data-id="element-157" />
            <span className="text-brand-cream italic" data-id="element-158">
              el Anclaje Sensorial
            </span>
          </h2>

          <div className="text-lg md:text-xl leading-relaxed space-y-6 text-brand-blueLight" data-id="element-159">
            <p data-id="element-160">
              La solución es el <strong data-id="element-161">Anclaje Sensorial</strong>. Es una
              secuencia física de{' '}
              <span className="text-white font-bold bg-white/20 px-2 py-1 rounded" data-id="element-162">
                7 minutos
              </span>{' '}
              diseñada para bajar el ritmo cardíaco de tu bebé de forma manual.
            </p>
            <p className="text-xl md:text-2xl font-serif text-white mt-8" data-id="element-163">
              No es un entrenamiento; es una intervención biológica que fuerza
              al sistema nervioso a pasar del estado de lucha al estado de
              reposo profundo en 360 segundos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}